import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

export default function RadioButton({
  buttonPosition, defaultChecked, groupName, label, labelClassName, onChange, value,
}) {
  return (
    <label className={`${styles.label} ${labelClassName}`}>
      {buttonPosition.toLowerCase() !== 'before' && label}
      <input defaultChecked={defaultChecked} name={groupName} type="radio" value={value} onChange={onChange} />
      {buttonPosition.toLowerCase() === 'before' && label}
    </label>
  );
}

RadioButton.propTypes = {
  buttonPosition: PropTypes.string,
  defaultChecked: PropTypes.bool,
  groupName: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string.isRequired,
};

RadioButton.defaultProps = {
  buttonPosition: 'before',
  defaultChecked: false,
  labelClassName: '',
};
